export const landingTokens = {
  gradient: "linear-gradient(135deg, #0060DF 0%, #0097FF 45%, #5EC8FF 100%)",
  shadow: "0 10px 30px -12px rgba(20,33,61,.18)",
  radius: {
    card: 20,
    badge: 16,
    button: 14,
  },
  transition: "transform 180ms ease, box-shadow 180ms ease",
};
